<template>
  <div class="section" v-if="mySelf">
    <v-card flat>
      <v-row>
        <v-col>
        <v-data-table
            lazy
            :headers="headers_section"
            :items="Sections"
            sort-by="name"
            class="elevation-1 caption"
            dense
            must-sort
            :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="50"
            item-class="caption"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Sektionen</v-toolbar-title>
                <br />
                
                <v-spacer></v-spacer>
               <v-btn color="green" left fab small dark class="mb-2" @click="createItemSection">
                  <v-icon>
                    add
                  </v-icon>
                </v-btn>
                <v-dialog v-model="dialog_section" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="subtitle-1">{{ formTitleSection }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-form
                        v-model="valid"
                        style="width: 100%; height: 100%"
                        class="compact-form"
                      >
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemSection.name"
                          label="Name"
                        ></v-text-field>
                         <v-checkbox
                          v-model="editedItemSection.active" label="Active"
                      ></v-checkbox>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeSection"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="saveSection"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItemSection(item)"
                >mdi-pencil</v-icon
              >
              
            </template>
           
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import api from "../api";
import { requiredRule } from "../utils/rules";


export default {
  name: "section",
  components: {},
  data() {
    return {
      valid: false,
      requiredRule,

      dialog_delete: false,
     
      dialog_section: false,
      headers_section: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Active", value: "active" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      editedIndexSection: -1,
      defaultItemSection: {
        name: "",
        active: true
      },

      editedItemSection: {},
      
      snackbar: false,
      snackbar_text: "",
  
    };
  },
  async mounted() {
    await this.getSections({});
    this.editedItemSection = this.defaultItemSection;
   
  },
  computed: {
    ...mapState({
      status: ({ section }) => section.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
      Sections: ({ section }) => section.Sections,
      SectionState: ({ section }) => section,

    }),


    formTitleSection() {
      return this.editedIndexSection === -1 ? "New Section" : "Edit Section";
    },
  },
  methods: {
    ...mapActions("section", [
      "getSections",
      "createSection",
      "updateSection"
    ]),
  
    createItemSection () {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog_section = true
      },
    async editItemSection(item) {
      //console.log("editItem");
      this.editedIndexSection = this.Sections.indexOf(item);
      this.editedItemSection = Object.assign({}, item);

      this.dialog_section = true;
    },

    async deleteItemSection(item) {
      const index = this.Sections.indexOf(item);
      await this.deleteSection(item._id);
      if (this.SectionState.statusDelete == "success") {
        this.Sections.splice(index, 1);
      } else {
        this.snackbar_text = "Already deleted";
        this.snackbar = true;
      }
    },

    closeSection() {
      this.dialog_section = false;
      this.$nextTick(() => {
        this.editedItemSection = Object.assign({}, this.defaultItem);
        this.editedIndexSection = -1;
      });
    },

    async saveSection() {
      //console.log("saveSection");

      //console.log(this.editedItemSection)

      if (this.editedIndexSection > -1) {
        await this.updateSection(this.editedItemSection);

        if (this.SectionState.statusUpdate == "success") {
          Object.assign(this.Sections[this.editedIndexSection], this.editedItemSection);
        } else {
          /*this.snackbar_text = this.SectionState;
          this.snackbar = true;*/
          //console.log(this.SectionState)
        }
      } else {
        await this.createSection(this.editedItemSection);
        if (this.SectionState.statusCreate == "success") {
          this.Sections.push(this.editedItemSection);
        } else {
          /*this.snackbar_text = this.snackbar_text = this.SectionState;
          this.snackbar = true;*/
          //console.log(this.SectionState)
        }
      }

      this.closeSection();
    },

  },
  watch: {
 
  },
};
</script>

<style>
.compact-form {
  transform: scale(0.9);
  transform-origin: left;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
   font-size: 10px !important;
}
</style>